const DiagnosticSection = () => (
  <section className="diagnostic-section" id="diagnostic">
    <div className="diagnostic-container">
      <div className="diagnostic-block">
        <span className="diagnostic-tag alert-tag">[ ERROR: SYSTEM DEFICIT ]</span>
        <h2 className="diagnostic-h2">YOU KNOW SOMETHING'S OFF.</h2>
        <p className="diagnostic-text">
          Your website makes your business look smaller than it is — even when the business itself is thriving. Your customers can't tell what makes you different. The site isn't bringing in new business. It exists, but it doesn't execute.
        </p>
      </div>

      <div className="diagnostic-block">
        <span className="diagnostic-tag">[ DIAGNOSIS: SYMPTOMATIC FATIGUE ]</span>
        <h3 className="diagnostic-h3">I GET IT.</h3>
        <p className="diagnostic-text">
          You've paid for websites that looked fine but never actually helped. And there's that small embarrassment every time a client visits your site.
        </p>
        <p className="diagnostic-text">
          You've given up on digital doing anything beyond existing.
        </p>
      </div>

      <div className="diagnostic-block">
        <span className="diagnostic-tag">[ ROOT CAUSE: SURFACE FIXATION ]</span>
        <h3 className="diagnostic-h3">WHERE THINGS USUALLY GO WRONG</h3>
        <p className="diagnostic-text">
          Most updates focus on the surface.
        </p>

        <div className="bridge-crash-block">
          NEW COLORS.<br />
          NEW LAYOUTS.<br />
          NEW TRENDS.
        </div>

        <p className="diagnostic-text mt-12 text-foreground font-extrabold">
          If the structural foundation doesn't match your operational reality, it won't matter how it looks.
        </p>
        <p className="diagnostic-text mt-6 text-foreground/60">
          I work with established businesses (typically 5–50 people) whose websites no longer reflect the strength of the company behind them — even when the business itself is thriving.
        </p>
      </div>
    </div>
  </section>
);

export default DiagnosticSection;
